// src/api/auth.js
import request, { clearAllAuthState } from "./client";

export const login = (payload) =>
    request("/auth/login", { method: "POST", body: payload });

export const logout = async () => {
    try {
        await request("/auth/logout", { method: "POST" });
    } finally {
        clearAllAuthState();
    }
};
export const signup = (payload = {}) => {
    const fd = new FormData();
    const append = (k, v) => {
        if (v === undefined || v === null) return;
        fd.append(k, typeof v === "boolean" ? String(v) : v);
    };
    append("name", payload.name);
    append("rrn_front", payload.rrn_front);   // 앞 6자리
    append("rrn_back1", payload.rrn_back1);   // 뒤 1자리
    append("phone", payload.phone);           // 010xxxxxxxx
    append("password", payload.password);
    append("consent_personal", payload.consent_personal);
    append("consent_tos", payload.consent_tos);
    append("consent_marketing", payload.consent_marketing);
    append("workplace", payload.workplace);
    if (payload.image instanceof File) fd.append("image", payload.image);
    return request("/auth/register", { method: "POST", body: fd });
};



export const me = () => request("/users/me");


export const updateMe = (payload = {}) => {
    const fd = new FormData();
    if (payload.name) fd.append("name", payload.name);
    if (payload.phone) fd.append("phone", payload.phone); // 예: 010-1234-5678
    if (payload.password) fd.append("password", payload.password);
    if (payload.workplace) fd.append("workplace", payload.workplace);
    if (typeof payload.consent_marketing === "boolean") {
        fd.append("consent_marketing", String(payload.consent_marketing));
    }
    if (payload.image instanceof File) {
        fd.append("image", payload.image);
    }
    return request("/users/me", { method: "PUT", body: fd });
};